import { OpenAPI } from '../../../openapi/core/OpenAPI'
import { request as __request } from '../../../openapi/core/request'

export type FallbackPlatform =
  'facebook' | 'instagram' | 'linkedin' | 'tiktok' | 'twitter' | 'youtube' | 'pinterest'
export type FallbackProviderId = 'phyllo' | 'composio'

/**
 * How the partner wants the user to link their account:
 *  - `redirect`: send the browser to `redirectUrl` (Composio's hosted consent).
 *  - `sdk`: launch the partner's web SDK with `sdkToken` (Phyllo Connect).
 * `gateway` is the partner id (matches the server's GatewayConnectSession).
 */
export type FallbackConnectSession =
  | {
      mode: 'redirect'
      gateway: FallbackProviderId
      redirectUrl: string
      externalUserId: string
    }
  | {
      mode: 'sdk'
      gateway: FallbackProviderId
      sdkToken: string
      externalUserId: string
      environment: string
    }

export interface FallbackPageSummary {
  id: string
  name: string
  picture?: string
  handle?: string
}

export interface FallbackPagesResponse {
  pages: FallbackPageSummary[]
}

export interface SelectFallbackPageResponse {
  success: boolean
  pageName?: string
}

// Thin handwritten wrappers around the fallback connect endpoints (mirrors
// facebook-pages-api.ts). Replace with generated calls after `yarn openapi`.
export const FallbackApi = {
  connectSession(body: { platform: FallbackPlatform }): Promise<FallbackConnectSession> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/integrations/fallback/connect-session',
      body,
      mediaType: 'application/json',
    })
  },
  listPages(query: {
    provider: FallbackProviderId
    externalUserId: string
    platform: FallbackPlatform
    connectAttemptId?: string
  }): Promise<FallbackPagesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/integrations/fallback/pages',
      query,
    })
  },
  selectPage(body: {
    provider: FallbackProviderId
    externalAccountId: string
    externalUserId: string
    platform: FallbackPlatform
    connectAttemptId?: string
  }): Promise<SelectFallbackPageResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/integrations/fallback/select-page',
      body,
      mediaType: 'application/json',
    })
  },
}
